// shared formatting utilities for the admin panel

const parseDateInput = (
  value: string | number | null | undefined
): Date | null => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    const numeric = Number(trimmed);
    const date = Number.isFinite(numeric)
      ? new Date(numeric)
      : new Date(trimmed);
    return isNaN(date.getTime()) ? null : date;
  }

  const date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
};

/**
 * Format date as DD.MM.YYYY
 * @param dateString
 */
export const formatDate = (
  dateString: string | number | null | undefined
): string => {
  const date = parseDateInput(dateString);
  if (!date) {
    return '-';
  }
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

/**
 * Format date with time as DD.MM.YYYY HH:mm
 * @param dateString
 */
export const formatDateTime = (
  dateString: string | number | null | undefined
): string => {
  const date = parseDateInput(dateString);
  if (!date) {
    return '-';
  }
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

/**
 * Get row class name for zebra-striping in tables
 * @param rowData
 * @param rowIndex
 */
export const getRowClassName = (
  rowData: Record<string, unknown>,
  rowIndex?: number
): string => {
  if (rowIndex === undefined) {
    return '';
  }
  return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
};
